/* CATEGORY - SUBCATEGORy */
export const GET_CATEGORIES_SUBCATEGORIES = "GET_CATEGORIES_SUBCATEGORIES"
export const GET_CATEGORIES_SUBCATEGORIES_SUCCESS = "GET_CATEGORIES_SUBCATEGORIES_SUCCESS"
export const GET_CATEGORIES_SUBCATEGORIES_FAIL = "GET_CATEGORIES_SUBCATEGORIES_FAIL"

export const GET_HSNS = "GET_HSNS"
export const GET_HSNS_SUCCESS = "GET_HSNS_SUCCESS"
export const GET_HSNS_FAIL = "GET_HSNS_FAIL"

export const GET_UNITS = "GET_UNITS"
export const GET_UNITS_SUCCESS = "GET_UNITS_SUCCESS"
export const GET_UNITS_FAIL = "GET_UNITS_FAIL"

export const GET_ALLCOA = "GET_ALLCOA"
export const GET_ALLCOA_SUCCESS = "GET_ALLCOA_SUCCESS"
export const GET_ALLCOA_FAIL = "GET_ALLCOA_FAIL"

export const GET_ALL_PRODUCTS = "GET_ALL_PRODUCTS"
export const GET_ALL_PRODUCTS_SUCCESS = "GET_ALL_PRODUCTS_SUCCESS"
export const GET_ALL_PRODUCTS_FAIL = "GET_ALL_PRODUCTS_FAIL"

export const GET_PRODUCT_FOR_EDIT = "GET_PRODUCT_FOR_EDIT"
export const GET_PRODUCT_FOR_EDIT_SUCCESS = "GET_PRODUCT_FOR_EDIT_SUCCESS"
export const GET_PRODUCT_FOR_EDIT_FAIL = "GET_PRODUCT_FOR_EDIT_FAIL"

export const GET_MANUFACTURERS = "GET_MANUFACTURERS"
export const GET_MANUFACTURERS_SUCCESS = "GET_MANUFACTURERS_SUCCESS"
export const GET_MANUFACTURERS_FAIL = "GET_MANUFACTURERS_FAIL"

export const GET_TAXES = "GET_TAXES"
export const GET_TAXES_SUCCESS = "GET_TAXES_SUCCESS"
export const GET_TAXES_FAIL = "GET_TAXES_FAIL"

export const GET_BRANDS = "GET_BRANDS"
export const GET_BRANDS_SUCCESS = "GET_BRANDS_SUCCESS"
export const GET_BRANDS_FAIL = "GET_BRANDS_FAIL"

export const GET_SUPPLIERS = "GET_SUPPLIERS"
export const GET_SUPPLIERS_SUCCESS = "GET_SUPPLIERS_SUCCESS"
export const GET_SUPPLIERS_FAIL = "GET_SUPPLIERS_FAIL"

export const GET_ALL_CUSTOMERS = "GET_ALL_CUSTOMERS"
export const GET_ALL_CUSTOMERS_SUCCESS = "GET_ALL_CUSTOMERS_SUCCESS"
export const GET_ALL_CUSTOMERS_FAIL = "GET_ALL_CUSTOMERS_FAIL"

export const GET_ALL_EMPLOYEES = "GET_ALL_EMPLOYEES"
export const GET_ALL_EMPLOYEES_SUCCESS = "GET_ALL_EMPLOYEES_SUCCESS"
export const GET_ALL_EMPLOYEES_FAIL = "GET_ALL_EMPLOYEES_FAIL"

export const GET_ALL_BANKS = "GET_ALL_BANKS"
export const GET_ALL_BANKS_SUCCESS = "GET_ALL_BANKS_SUCCESS"
export const GET_ALL_BANKS_FAIL = "GET_ALL_BANKS_FAIL"

export const GET_COLOURS = "GET_COLOURS"
export const GET_COLOURS_SUCCESS = "GET_COLOURS_SUCCESS"
export const GET_COLOURS_FAIL = "GET_COLOURS_FAIL"

export const GET_SIZES = "GET_SIZES"
export const GET_SIZES_SUCCESS = "GET_SIZES_SUCCESS"
export const GET_SIZES_FAIL = "GET_SIZES_FAIL"

export const ADD_NEW_ITEM = "ADD_NEW_ITEM"
export const ADD_NEW_ITEM_SUCCESS = "ADD_NEW_ITEM_SUCCESS"
export const ADD_NEW_ITEM_FAIL = "ADD_NEW_ITEM_FAIL"

export const RESET_ERROR_AND_RESP = "RESET_ERROR_AND_RESP"
export const SET_TIMER = "SET_TIMER"

export const ADD_NEW_MAJOR_ITEM = "ADD_NEW_MAJOR_ITEM"
export const ADD_NEW_MAJOR_ITEM_SUCCESS = "ADD_NEW_MAJOR_ITEM_SUCCESS"
export const ADD_NEW_MAJOR_ITEM_FAIL = "ADD_NEW_MAJOR_ITEM_FAIL"

export const EDIT_ITEM = "EDIT_ITEM"
export const EDIT_ITEM_SUCCESS = "EDIT_ITEM_SUCCESS"
export const EDIT_ITEM_FAIL = "EDIT_ITEM_FAIL"

export const DELETE_ITEM = "DELETE_ITEM"
export const DELETE_ITEM_SUCCESS = "DELETE_ITEM_SUCCESS"
export const DELETE_ITEM_FAIL = "DELETE_ITEM_FAIL"

export const GET_SETTINGS = "GET_SETTINGS"
export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS"
export const GET_SETTINGS_FAIL = "GET_SETTINGS_FAIL"

export const GET_LEDGER_DETAILS = "GET_LEDGER_DETAILS"
export const GET_LEDGER_DETAILS_SUCCESS = "GET_LEDGER_DETAILS_SUCCESS"
export const GET_LEDGER_DETAILS_FAIL = "GET_LEDGER_DETAILS_FAIL"